import { render, staticRenderFns } from "./answerItem.vue?vue&type=template&id=0db81e50&scoped=true"
import script from "./answerItem.vue?vue&type=script&lang=js"
export * from "./answerItem.vue?vue&type=script&lang=js"
import style0 from "./answerItem.vue?vue&type=style&index=0&id=0db81e50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db81e50",
  null
  
)

export default component.exports